import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWoningTerugverkopen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="m20 5 13 10v20H7V15z"
      clipRule="evenodd"
    />
    <path
      stroke="#F170B8"
      strokeMiterlimit={10}
      strokeWidth={4}
      d="M20 29h2.04c3.04 0 5.5-2.46 5.5-5.5s-2.46-5.5-5.5-5.5H15"
    />
    <path
      stroke="#00215B"
      strokeMiterlimit={10}
      d="m33.4 17.71-8.49-6.79"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M17.97 24 11 18l6.97-6z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWoningTerugverkopen);

export default ForwardRef;
